


















































import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import GraphData, {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import BarChart from "@/charts/BarChart.vue";
import jsonURLTotal from "@/shared/UrlsTotal";
import moment from "moment/moment";
import ChartsCommon from "./chartsMixin";
import TotalGraphMixin from "./totalGraphMixins";

@Component({
  components: {
    BarChart,
  },
})
export default class TotalBarGraph extends mixins(
  ChartsCommon,
  TotalGraphMixin
) {
  public dataGetted = false;
  public data: Array<DataSet> = [];
  public options: ChartOptions = new ChartOptions();
  public datasets: { [k: string]: any } = {};
  public series: Array<string> = new Array();
  // public datasetsLabels
  public config: any;
  public selectedSerie = "";
  public internalLabels: string[] = [];

  @Prop({ default: new DataSet() }) public previousData!: DataSet;
  @Prop({ default: [] }) public labels!: Array<string>;
  @Prop() public myOptions!: MyOptions;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  @Watch("previousData", { immediate: true, deep: true })
  public onPreviousDataChanged(value: any, oldValue: any) {
    if (this.client !== "TOTAL" && value && value.data && value.data.length > 0) {
      this.data = [value];
      this.setOptions();
      this.dataGetted = true;
    }
  }

  @Watch("labels", { immediate: true, deep: true })
  public onLabelsChanged(value: any, oldValue: any) {
    // Lorsque les labels changent
  }

  public mounted() {
    // moment.locale("fr");
  }

  public init() {
    this.dataGetted = false;
    this.config = {
      site: this.myOptions.site[0],
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    this.updateWs();
    const titre =
      this.client === "TOTAL"
        ? this.$t("CaParEquipement").toString()
        : "Couvert moyen par vendeur";
    if (this.client === "TOTAL") {
      this.orderTitre(this.myOptions, titre);
      this.$store
        .dispatch("home/getGraphDataTotal", this.config)
        .then((data: any) => {
          this.orderData(data);
          this.setOptions();
        });
    } else {
      this.data = [this.previousData];
      this.setOptions();
      this.dataGetted = true;
    }
  }

  /*
   * methode de changement de l'équipement dont on veut afficher les ventes
   */
  public changeSelectedSerie(label: string) {
    this.selectedSerie = label;
    this.data = new Array();
    this.data.push(this.datasets[label].data);
    this.internalLabels = this.datasets[label].labels;
  }

  private getSum(values: any) {
    // console.log(values);
    let sum = 0;
    Object.keys(values).forEach((val: any) => {
      // console.log(val);
      sum += values[val][0];
    });
    return sum;
  }

  /**
   * mise a jour du web service en fonction de la periode
   */
  private updateWs() {
    switch (this.myOptions.periode) {
      case "J":
        this.config.WS = jsonURLTotal.VENTE_ART_JOUR_PAR_EQUIPEMENT;
        break;
      case "MOIS":
        this.config.WS = jsonURLTotal.VENTE_ART_MOIS_PAR_EQUIPEMENT;
        break;
      case "ANNEE":
        this.config.WS = jsonURLTotal.VENTE_ART_ANNEE_PAR_EQUIPEMENT;
        break;
    }
  }

  /**
   * methode permettant de mettre à jour les options du graphique
   */
  private setOptions() {
    this.options.makeMeABarGraph();
  }

  /**
   * mise en forme des données
   */
  private orderData(lignes: any) {
    // 1: vente, 0 : presta
    // console.log(lignes);
    const keyAll = this.$t("TOUS").toString();
    this.series = Object.keys(lignes);
    this.series.unshift(keyAll);

    const dataSetAll: DataSet = new DataSet();
    dataSetAll.label = keyAll;
    dataSetAll.data = new Array();
    Object.keys(lignes).forEach((label: string) => {
      if (label !== "") {
        const sum = this.getSum(lignes[label]);
        dataSetAll.data.push(sum);
      }
    });
    this.datasets[keyAll] = {
      data: dataSetAll,
      labels: Object.keys(lignes),
    };

    Object.keys(lignes).forEach((eq: string) => {
      const dataSet: DataSet = new DataSet();
      dataSet.label = eq;
      dataSet.data = new Array();
      const madata = lignes[eq];
      const progs = Object.keys(lignes[eq]);
      // console.log(madata);

      progs.forEach((prog: string) => {
        if (prog !== "") {
          dataSet.data.push(madata[prog][0]);
        }
        this.datasets[eq] = {
          data: dataSet,
          labels: progs,
        };
      });
    });
    console.log(this.datasets);

    this.changeSelectedSerie(keyAll);
    this.dataGetted = true;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
